module.exports = __webpack_public_path__ + "img/probot-avatar.75ea5489.svg";